"use client";

import type { SectionItem, TrustedCollection } from "@packages/sdk";
import { useRequestFavorites, useSession } from "@packages/sdk";
import { Loader } from "@packages/ui";

import CollectionContent from "./CollectionContent";

interface CollectionFilteredProps {
  filter: string | string[];
  collection: TrustedCollection;
}

export default function CollectionFiltered({
  filter,
  collection,
}: CollectionFilteredProps) {
  useSession({ required: true });

  const { query: favoritesQuery } = useRequestFavorites({
    displayType: "sessions",
  });

  if (favoritesQuery.isPending) {
    return <Loader />;
  }

  if (favoritesQuery.isError) {
    return <div>Error</div>;
  }

  const filterIds =
    filter === "favorites"
      ? (favoritesQuery.data?.items ?? []).map(
          (item: SectionItem) => item.item_id,
        )
      : [];

  const filteredCollection = {
    ...collection,
    prayers:
      collection.prayers.filter((prayer) =>
        (filterIds ?? []).includes(prayer.id),
      ) ?? [],
  };

  return (
    <CollectionContent
      collection={filteredCollection}
      filtered={filteredCollection.prayers.length < collection.prayers.length}
    />
  );
}
